import { AfterViewInit, ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { SearchTicketsService } from '@sb-tools/typescript/services/search-tickets.service';
import { ActivatedRoute, Params, Router, RouterLink } from '@angular/router';
import { TicketListItemDTO } from '@sb-tools/typescript/models/dto/ticket-list-item.dto';
import { SideNavigationService } from 'src/sb-tools/typescript/services/side-navigation.service';
import $ from 'jquery';
import { CommonDataService } from 'src/sb-tools/typescript/services/common-data.service';
import { ComponentMessengerService } from '../core/services/component-messenger.service';
import { RightPanelService } from '../core/services/right-panel.service';
import { SignalRService } from '../core/services/signalR.service';
import { TicketDetailsPanelService } from '../core/services/ticket-details-panel.service';
import { filter, take, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/internal/Subject';
import { WindowRef } from 'src/sb-tools/typescript/services/window-ref.service';
import { TicketRightPanelService } from '../core/services/ticket-right-panel.service';
import { FieldsSearchService } from '@sb-tools/typescript/services/fields-search.service';
import { DOWN_ARROW, UP_ARROW } from 'src/sb-tools/typescript/constants/keycodes';
import { TicketListService } from '@form-field-module/common/services/ticket-list.service';
import { OrderBy } from '@sb-tools/typescript/enums/order-by.enum';
import { TicketFolder } from '@sb-tools/typescript/enums/ticket-folder.enum';
import { TicketStatus } from '@sb-tools/typescript/enums/ticket-status.enum';
import { TicketsSearchRequest } from '../core/models/tickets-search-request.model';
import { LocalStorageService } from '@sb-tools/typescript/services/local-storage.service';
import { SidenavComponent } from '@sb-tools/typescript/components/sidenav/sidenav.component';
import { LeftMenuComponent } from './left-menu/left-menu.component';
import { TopMenuComponent } from '../top-menu/top-menu.component';
import { NgClass } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { NgFooterTemplateDirective, NgOptionComponent, NgSelectComponent } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { InlineSVGComponent } from '../../sb-modules/Frontend-Inline-SVG-Module/inline-svg.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { TicketListItemComponent } from './ticket-list-item/ticket-list-item.component';
import { LoaderComponent } from '@sb-tools/typescript/components/loader/loader.component';
import { ResizerComponent } from '../shared/components/resizer/resizer.component';
import { TicketBulkOperationsComponent } from './ticket-bulk-operations/ticket-bulk-operations.component';
import { TicketDetailsComponent } from '../ticket-details/ticket-details.component';
import { RightPanelComponent } from '../right-panel/right-panel.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TicketsOrderByPipe } from '@sb-tools/typescript/pipes/tickets-order-by.pipe';
import { ShortNumberPipe } from '../shared/pipes/short-number.pipe';
import { isInboxLeftSidebarVisible } from '../core/utils/is-inbox-left-sidebar-visible.util';
import { TicketSignalRDTO } from '../core/models/dto/signalR/ticket-signalr.dto';
import { InboxElementsVisibility } from '@sb-tools/typescript/models/inbox-elements-visibility.model';
import { isInboxElementVisible } from '../core/utils/is-inbox-element-visible.util';
import { OpenTicketInNewWindowService } from '../core/services/ticket/open-ticket-in-new-window.service';

@Component({
    selector: 'app-ticket-list',
    templateUrl: './ticket-list.component.html',
    styleUrls: ['./ticket-list.component.scss'],
    imports: [
        SidenavComponent,
        LeftMenuComponent,
        TopMenuComponent,
        NgClass,
        RouterLink,
        TranslateModule,
        NgSelectComponent,
        FormsModule,
        NgOptionComponent,
        NgFooterTemplateDirective,
        TooltipModule,
        InlineSVGComponent,
        InfiniteScrollModule,
        TicketListItemComponent,
        LoaderComponent,
        ResizerComponent,
        TicketBulkOperationsComponent,
        TicketDetailsComponent,
        RightPanelComponent,
        ModalModule,
        TicketsOrderByPipe,
        ShortNumberPipe,
    ],
})
export class TicketListComponent implements OnInit, AfterViewInit, OnDestroy {
    activeStatus: number;
    areAllTicketsLoaded = false;
    communityName: string;
    count = 30;
    isLoadingTickets = false;
    isNoTicketsMatchThisCriteria: boolean;
    isUnassignedOrAssignedToMe: boolean;
    lastTicketsLength: number;
    orderBy;
    orderByEnum = OrderBy;
    queryParams: any = {};
    selectedTicketItemId: number;
    selectedTickets = [];
    showEmptyTicketsState = false;
    showTicketDetailsEmptyState = false;
    showResultsCount: number | string;
    ticketStatusEnum = TicketStatus;
    tickets: TicketListItemDTO[] = [];
    totalResultsCount = 0;
    emptyTicketsTitle = 'No tickets';
    isSearchContextTransitioning = false;

    private _queryParams: any = {};
    private feedUpdateCount = 0;
    private isFirstLoad = true;
    private lastSelectedTicket;
    private oldSearchParams: any = {};
    private searchRequest;
    private selectedTicketItem;
    private timerId;
    private unsubscriber = new Subject<void>();

    @HostListener('document:click', ['$event'])
    handleDocumentClick(event: MouseEvent): void {
        this.ticketListService.setTicketListActiveStatus(event);
    }

    constructor(
        private searchTicketsService: SearchTicketsService,
        private activatedRoute: ActivatedRoute,
        public sideNavigationService: SideNavigationService,
        public commonDataService: CommonDataService,
        private router: Router,
        private componentMessengerService: ComponentMessengerService,
        public rightPanelService: RightPanelService,
        public ticketRightPanelService: TicketRightPanelService,
        private signalRService: SignalRService,
        public ticketDetailsPanelService: TicketDetailsPanelService,
        private windowRef: WindowRef,
        private fieldsSearchService: FieldsSearchService,
        public ticketListService: TicketListService,
        private localStorageService: LocalStorageService,
        private changeDetectorRef: ChangeDetectorRef,
        private openTicketInNewWindowService: OpenTicketInNewWindowService,
    ) {}

    ngOnInit(): void {
        this.ticketListService.isTicketListActive = true;
        this.communityName = this.commonDataService.communityName;

        this.isUnassignedOrAssignedToMe =
            this.localStorageService.getItem(this.getIsUnassignedOrAssignedToMeKey()) === 'true';

        this.activatedRoute.queryParams
            .pipe(
                filter((params) => {
                    return this.isSearchChanged(params);
                }),
                takeUntil(this.unsubscriber),
            )
            .subscribe((params) => {
                if (String(params.emptySelection) === '1') {
                    this.router.navigate([], {
                        relativeTo: this.activatedRoute,
                        queryParams: { emptySelection: null, nextTicketAfterClose: null },
                        queryParamsHandling: 'merge',
                        replaceUrl: true,
                    });

                    return;
                }

                if (this.redirectToOpenIfStatusHidden(params)) {
                    return;
                }

                this.isFirstLoad = false;
                this.cleanSelectedTickets();
                this._queryParams = params;
                this.queryParams = params;
                this.activeStatus = +this.queryParams.status;

                this.lastTicketsLength = this.tickets.length;
                this.tickets.length = 0;
                this.isSearchContextTransitioning = true;
                this.updateEmptyStates();
                this.loadMore(true);
            });

        this.activatedRoute.queryParams.pipe(takeUntil(this.unsubscriber)).subscribe((params) => {
            this.setOrderBy(params);

            if (params.ticketId) {
                this.cleanSelectedTickets();
                this.selectedTicketItemId = +params.ticketId;
                this.isSearchContextTransitioning = false;
                this.ticketDetailsPanelService.open(+params.ticketId);
            } else {
                this.selectedTicketItemId = null;
                this.ticketDetailsPanelService.close();
                if (this.shouldAutoSelectFirstTicket() && !this.isSearchContextTransitioning) {
                    this.selectFirstTicketInList();
                }
                this.signalRService.selectedTicketChanged(null).pipe(take(1)).subscribe();
            }

            this.updateEmptyStates();
        });

        this.signalRService
            .onTicketListUpdated()
            .pipe(takeUntil(this.unsubscriber))
            .subscribe(() => {
                this.feedUpdateCount++;
                console.log('%c onRefreshFeed: ' + this.feedUpdateCount, 'color: green');
                this.loadMore(true);
            });

        this.signalRService
            .onTicketUpdated()
            .pipe(takeUntil(this.unsubscriber))
            .subscribe((data) => {
                this.updateTicketListItem(data.ticket.id, data.ticket);
            });

        this.signalRService
            .onUserUpdated()
            .pipe(takeUntil(this.unsubscriber))
            .subscribe(({ userId, name }) => {
                this.tickets
                    .filter((ticket) => ticket.firstMessageCreator?.id === userId)
                    .forEach((ticket) => {
                        ticket.firstMessageCreator.name = name;
                        ticket.changeDetectionMarker = new Date().getTime();
                    });
            });

        this.signalRService
            .onTicketPropertiesUpdated()
            .pipe(takeUntil(this.unsubscriber))
            .subscribe((data) => {
                this.updateTicketListItem(data.ticketId, data.ticketProperties);
            });

        this.signalRService
            .onConnected()
            .pipe(takeUntil(this.unsubscriber))
            .subscribe(() => {
                this.setOrderBy(this._queryParams);
                const searchParams = this.getParams();
                this.signalRService.searchRequestChanged(searchParams).pipe(take(1)).subscribe();
            });

        this.componentMessengerService.ticketListMessage
            .pipe(takeUntil(this.unsubscriber))
            .subscribe((isNeedToReload) => {
                if (isNeedToReload) {
                    this.loadMore(true);
                }
            });
    }

    ngAfterViewInit(): void {
        // Fix for ExpressionChangedAfterItHasBeenCheckedError
        // Ensure all changes are detected after the initial change detection cycle
        this.changeDetectorRef.detectChanges();
    }

    handleIsUnassignedOrAssignedToMe(): void {
        this.localStorageService.setItem(
            this.getIsUnassignedOrAssignedToMeKey(),
            this.isUnassignedOrAssignedToMe.toString(),
        );
        this.loadMore(true);
    }

    isLeftSidebarVisible(): boolean {
        return isInboxLeftSidebarVisible(
            this.commonDataService.user,
            this.commonDataService.customerSettings,
            this.commonDataService.hasVisibleLeftMenuFilters,
        );
    }

    isTicketSortingDropdownVisible(): boolean {
        return isInboxElementVisible(
            this.commonDataService.customerSettings?.inboxElementsVisibility?.ticketSortingDropdown,
        );
    }

    isTicketStatusFilterVisible(key: keyof NonNullable<InboxElementsVisibility['ticketStatusFilters']>): boolean {
        return isInboxElementVisible(
            this.commonDataService.customerSettings?.inboxElementsVisibility?.ticketStatusFilters?.[key],
        );
    }

    private redirectToOpenIfStatusHidden(params: Params): boolean {
        const status =
            params.status === undefined || params.status === null || params.status === ''
                ? TicketStatus.all
                : +params.status;
        let visibilityKey: keyof NonNullable<InboxElementsVisibility['ticketStatusFilters']>;

        switch (status) {
            case TicketStatus.pending:
                visibilityKey = 'pending';
                break;
            case TicketStatus.completed:
                visibilityKey = 'closed';
                break;
            case TicketStatus.all:
            case TicketStatus.notCompleted:
                visibilityKey = 'all';
                break;
            default:
                return false;
        }

        if (this.isTicketStatusFilterVisible(visibilityKey)) {
            return false;
        }

        void this.router.navigate([], {
            relativeTo: this.activatedRoute,
            queryParams: { status: TicketStatus.open, ticketId: '' },
            queryParamsHandling: 'merge',
            replaceUrl: true,
        });

        return true;
    }

    // todo: check it is necessary?
    checkLinkClick(event): void {
        if (
            $(event.target).closest('.link-content-wrapper').length &&
            $(event.target).closest('.nav-item').hasClass('active')
        ) {
            event.stopPropagation();
        }
    }

    clickTicket(event, ticket): void {
        this.ticketDetailsPanelService.clickTime = new Date().getTime();
        event.preventDefault();
        event.stopPropagation();

        if (!this.ticketRightPanelService.isNeedToDiscardUnsavedChanges()) {
            return;
        }

        this.ticketListService.isTicketListActive = true;

        if (event.ctrlKey || event.shiftKey || event.metaKey) {
            if (!this.selectedTickets.length && this.activatedRoute.snapshot.queryParams.ticketId) {
                const currentTicket = this.tickets.find((item) => {
                    return item.id === +this.activatedRoute.snapshot.queryParams.ticketId;
                });

                this.selectTicket(currentTicket);

                this.lastSelectedTicket = currentTicket;

                this.ticketDetailsPanelService.close();
            }

            if (
                this.selectedTickets.find((selectedTicket) => {
                    return selectedTicket.id === ticket.id;
                })
            ) {
                ticket.isSelected = false;
                this.selectedTickets = this.selectedTickets.filter((selectedTicket) => {
                    return selectedTicket.id !== ticket.id;
                });
            } else {
                this.selectTicket(ticket);

                if (event.shiftKey && this.lastSelectedTicket) {
                    const selectedTicketIndex = this.tickets.findIndex((item) => {
                        return item.id === ticket.id;
                    });

                    const lastSelectedTicketIndex = this.tickets.findIndex((item) => {
                        return item.id === this.lastSelectedTicket.id;
                    });

                    if (selectedTicketIndex !== -1 && lastSelectedTicketIndex !== -1) {
                        if (selectedTicketIndex > lastSelectedTicketIndex) {
                            for (let i = lastSelectedTicketIndex; i <= selectedTicketIndex; ++i) {
                                this.selectTicket(this.tickets[i]);
                            }
                        }

                        if (selectedTicketIndex < lastSelectedTicketIndex) {
                            for (let i = selectedTicketIndex; i <= lastSelectedTicketIndex; ++i) {
                                this.selectTicket(this.tickets[i]);
                            }
                        }
                    }
                }

                this.lastSelectedTicket = ticket;
            }
        } else {
            this.lastSelectedTicket = ticket;

            this.cleanSelectedTickets();
            this.selectedTicketItemId = ticket.id;

            this.ticketDetailsPanelService.open(ticket.id, false, true);
        }

        this.updateEmptyStates();
    }

    handleBulkTicketsClosed(closedTicketIds: number[]): void {
        closedTicketIds.forEach((ticketId) => this.openTicketInNewWindowService.closeTicketWindow(ticketId));

        if (this.commonDataService.customerSettings.isClosedTicketRemovedFromView !== true) {
            return;
        }

        const remainingSelectedTickets = this.selectedTickets.filter((ticket) => !closedTicketIds.includes(ticket.id));
        if (remainingSelectedTickets.length === this.selectedTickets.length) {
            return;
        }

        this.selectedTickets.forEach((ticket) => {
            if (closedTicketIds.includes(ticket.id)) {
                ticket.isSelected = false;
            }
        });
        this.selectedTickets = remainingSelectedTickets;
        this.selectedTicketItemId = null;

        const automaticallyOpenNext =
            !this.selectedTickets.length &&
            this.commonDataService.customerSettings.isNextTicketAutomaticallyOpened === true;
        this.ticketDetailsPanelService
            .setExplicitEmptySelection(undefined, automaticallyOpenNext, closedTicketIds)
            .then(() => {
                if (!this.selectedTickets.length) {
                    this.loadMore(true);
                }
            });
    }

    loadMore(isReload?): boolean {
        if (isReload && this.selectedTickets.length) {
            return false;
        }

        if ((this.commonDataService.isDisableTicketsLoading || this.isLoadingTickets) && !isReload) {
            return;
        }

        this.setOrderBy(this._queryParams);
        const searchParams: TicketsSearchRequest = this.getParams();

        if (!searchParams.query) {
            this.commonDataService.searchQuery = '';
        }

        if (this.areAllTicketsLoaded && !this.isSearchParamsChanged(searchParams) && !isReload) {
            return;
        }

        this.areAllTicketsLoaded = false;

        if (isReload) {
            searchParams.count = searchParams.skip || this.count;

            if (searchParams.count < this.count) {
                searchParams.count = this.count;
            } else {
                const remainder = searchParams.count % this.count;
                if (remainder) {
                    searchParams.count += this.count - remainder;
                }
            }

            searchParams.count += searchParams.count % this.count;

            searchParams.skip = 0;
        }

        if (!isReload && !this.isSearchParamsChanged(searchParams)) {
            return;
        }

        if (isReload && this.isSearchParamsChanged(searchParams)) {
            this.signalRService.searchRequestChanged(searchParams).pipe(take(1)).subscribe();
        }

        if (!isReload) {
            this.lastTicketsLength = this.tickets.length;
        }
        this.isLoadingTickets = true;
        this.updateEmptyStates();
        if (this.searchRequest) {
            this.searchRequest.unsubscribe();
        }

        this.searchRequest = this.searchTicketsService
            .get(searchParams)
            .pipe(takeUntil(this.unsubscriber))
            .subscribe((data) => {
                this.isNoTicketsMatchThisCriteria = false;

                if (isReload) {
                    this.tickets.length = 0;
                }

                this.totalResultsCount = data.totalResultsCount;
                this.showResultsCount = this.getTotalResultCount();
                // tickets
                if (data.items.length !== null && data.items.length < this.count) {
                    this.areAllTicketsLoaded = true;
                }

                Array.prototype.push.apply(this.tickets, data.items);
                this.showResultsCount = this.getTotalResultCount();
                setTimeout(() => {
                    this.oldSearchParams = structuredClone(searchParams);
                    this.isLoadingTickets = false;

                    this.isNoTicketsMatchThisCriteria = this._isNoTicketsMatchThisCriteria();
                    this.updateEmptyStates();
                }, 50);

                const { ticketId, nextTicketAfterClose } = this.activatedRoute.snapshot.queryParams;
                if (!ticketId && nextTicketAfterClose) {
                    const closedTicketIds = String(nextTicketAfterClose).split(',').map(Number);
                    const nextTicket = this.tickets.find((ticket) => !closedTicketIds.includes(ticket.id));
                    this.selectedTicketItemId = nextTicket?.id ?? null;
                    this.finishSearchContextTransition();
                    if (nextTicket) {
                        this.ticketDetailsPanelService.open(nextTicket.id, true, true);
                    } else {
                        this.ticketDetailsPanelService.setExplicitEmptySelection();
                    }
                } else if (!ticketId && this.shouldAutoSelectFirstTicket()) {
                    this.selectFirstTicketInList();
                } else if (!ticketId) {
                    this.finishSearchContextTransition();
                }
            });
    }

    keyDown(event: KeyboardEvent): void {
        if (this.ticketListService.isTicketListActive && (event.keyCode === DOWN_ARROW || event.keyCode === UP_ARROW)) {
            let currentSelectedItemId: number;

            if (this.selectedTicketItemId) {
                currentSelectedItemId = +this.selectedTicketItemId;
            } else {
                currentSelectedItemId = +this.activatedRoute.snapshot.queryParams.ticketId;
            }
            const activeTicketIndex = this.tickets.findIndex((ticket) => {
                return ticket.id === currentSelectedItemId;
            });

            switch (event.keyCode) {
                case UP_ARROW: // this is the ascii of arrow up
                    event.preventDefault();
                    switch (activeTicketIndex) {
                        case -1:
                            this.selectedTicketItem = this.tickets[0];
                            break;
                        case 0:
                            this.selectedTicketItem = this.tickets[this.tickets.length - 1];
                            break;
                        default:
                            this.selectedTicketItem = this.tickets[activeTicketIndex - 1];
                    }

                    if (this.selectedTicketItem) {
                        this.selectedTicketItemId = this.selectedTicketItem.id;

                        if ($('#ticket-' + this.selectedTicketItemId).length) {
                            this.scrollToView(
                                $('#ticket-' + this.selectedTicketItemId)[0],
                                $('.search-results-container')[0],
                            );
                        }
                    }
                    break;
                case DOWN_ARROW: // this is the ascii of arrow down
                    event.preventDefault();
                    switch (activeTicketIndex) {
                        case -1:
                            this.selectedTicketItem = this.tickets[0];
                            break;
                        case this.tickets.length - 1:
                            this.selectedTicketItem = this.tickets[0];
                            break;
                        default:
                            this.selectedTicketItem = this.tickets[activeTicketIndex + 1];
                    }

                    if (this.selectedTicketItem) {
                        this.selectedTicketItemId = this.selectedTicketItem.id;
                        if ($('#ticket-' + this.selectedTicketItemId).length) {
                            this.scrollToView(
                                $('#ticket-' + this.selectedTicketItemId)[0],
                                $('.search-results-container')[0],
                            );
                        }
                    }

                    break;
            }

            clearTimeout(this.timerId);
            if (this.selectedTicketItemId) {
                this.timerId = setTimeout(() => {
                    this.ticketDetailsPanelService.open(this.selectedTicketItemId, false, true);
                }, 300);
            }
        }
    }

    sortTickets(newOrderBy: OrderBy): void {
        const ticketListSortingSettings = {
            defaultCommunityTicketListSorting: this.commonDataService.customerSettings.defaultTicketListSorting,
            defaultCommunityTicketListSortingLastUpdatedTime:
                this.commonDataService.customerSettings.defaultTicketListSortingLastUpdatedTime,
            ticketListSorting: newOrderBy,
        };
        this.windowRef.nativeWindow.localStorage.setItem(
            'ticketListSortingSettings',
            JSON.stringify(ticketListSortingSettings),
        );

        this.router.navigate([], {
            relativeTo: this.activatedRoute,
            queryParams: { orderBy: newOrderBy },
            queryParamsHandling: 'merge',
        });
    }

    private cleanSelectedTickets(): void {
        if (this.selectedTickets.length) {
            this.selectedTickets.forEach((ticket) => {
                ticket.isSelected = false;
            });

            this.selectedTickets.length = 0;
        }
    }

    private getIsUnassignedOrAssignedToMeKey(): string {
        return this.commonDataService.communityName + '-isUnassignedOrAssignedToMe';
    }

    private _isNoTicketsMatchThisCriteria(): boolean {
        const nonFilterParams = [
            'status',
            'folder',
            'onlyMy',
            'orderBy',
            'ticketId',
            'noteId',
            'replyId',
            'action',
            'emptySelection',
            'nextTicketAfterClose',
        ];
        const hasSearchCriteria =
            this.isUnassignedOrAssignedToMe ||
            Object.entries(this.queryParams).some(
                ([key, value]) =>
                    !nonFilterParams.includes(key) && value !== undefined && value !== null && value !== '',
            );

        return (
            !(this.commonDataService.socialMediaStatusesLoaded && this.isCurrentSourceEmpty()) &&
            !this.tickets.length &&
            !this.isLoadingTickets &&
            hasSearchCriteria
        );
    }

    private isSearchParamsChanged(searchParams): boolean {
        return JSON.stringify(searchParams) !== JSON.stringify(this.oldSearchParams);
    }

    private getParams(isEmptyQuery?, ticketId?): TicketsSearchRequest {
        const searchParams: TicketsSearchRequest = {
            //     query: isEmptyQuery || !$rootScope.shared.query ? '' : $rootScope.shared.query,
            usersQuery: this._queryParams['usersQuery'],
            threadQuery: this._queryParams['threadQuery'],
            fieldsQuery: this._queryParams['fieldsQuery'],
            count: this.count,
            skip: this.tickets.length,
            folder: +this._queryParams['folder'] || null,
            sentiment: +this._queryParams['sentiment'] || null,
            source: +this._queryParams['source'] || null,
            tagIds: !this._queryParams['tagIds'] ? [] : this._queryParams['tagIds'].split(','),
            categoryIds: !this._queryParams['categoryIds'] ? [] : this._queryParams['categoryIds'].split(','),
            creationDateFilter: null,
            orderBy: this.orderBy,
            adminView: this._queryParams['onlyMy'] !== 'true',
            fromDate: this._queryParams['fromDate'] || null,
            toDate: this._queryParams['toDate'] || null,
            isOnlyHelperCategories: this._queryParams['isOnlyHelperCategories']
                ? JSON.parse(this._queryParams['isOnlyHelperCategories'])
                : null,
            sourceSubtype: +this._queryParams['sourceSubtype'] || null,

            replyFromDate: this._queryParams['replyFromDate'] || null,
            replyToDate: this._queryParams['replyToDate'] || null,
            hasAttachments: this._queryParams['hasAttachments']
                ? JSON.parse(this._queryParams['hasAttachments'])
                : null,
            hasNoReplyFromTeam:
                this._queryParams['hasNoReplyFromTeam'] === 'true'
                    ? JSON.parse(this._queryParams['hasNoReplyFromTeam'])
                    : null,
            withoutCategory: this._queryParams['withoutCategory'] === 'true' || null,
            repliedBy: !this._queryParams['repliedBy'] ? [] : this._queryParams['repliedBy'].split(','),
            fields: !this._queryParams['fields']
                ? []
                : this.fieldsSearchService.getDecodedValue(this._queryParams['fields']),
            createdBy: this._queryParams['createdBy'] || null,
            ticketId: ticketId || null, // $location.search().ticketId
            isAssignedToBot: this._queryParams['isAssignedToBot']
                ? JSON.parse(this._queryParams['isAssignedToBot'])
                : null,
            query: this._queryParams['query'],
            status: +this._queryParams.status || null,
            lastUpdateDaysDuration: this._queryParams.lastUpdateDaysDuration || null,
            closedByAnyAgentFromGroup: this._queryParams.closedByAnyAgentFromGroup || null,
            closedByAgent: this._queryParams.closedByAgent || null,
            assignees: !this._queryParams['assignees'] ? [] : this._queryParams['assignees'].split(','),
            assigneeUserGroupIds: !this._queryParams['assigneeUserGroupIds']
                ? []
                : this._queryParams['assigneeUserGroupIds'].split(','),
            isAssigned: this._queryParams.isAssigned ? JSON.parse(this._queryParams.isAssigned) : null,
            onlyMy: this._queryParams['onlyMy'] ? JSON.parse(this._queryParams['onlyMy']) : null,
            isUnassignedOrAssignedToMe: this.isUnassignedOrAssignedToMe,
            linkedToTicket: +this._queryParams['linkedToTicket'] || null,
        } as any;
        // todo: remove 'as any';

        if (
            this._queryParams['creationDateFilterType'] ||
            this._queryParams['creationDateFilterFrom'] ||
            this._queryParams['creationDateFilterTo'] ||
            this._queryParams['creationDateFilterUnit'] ||
            this._queryParams['creationDateFilterValue']
        ) {
            searchParams.creationDateFilter = {
                type: +this._queryParams['creationDateFilterType'] || null,
                from: this._queryParams['creationDateFilterFrom'] || null,
                to: this._queryParams['creationDateFilterTo'] || null,
                unit: +this._queryParams['creationDateFilterUnit'] || null,
                value: +this._queryParams['creationDateFilterValue'] || null,
            };
        }

        for (const key in searchParams) {
            if (Object.prototype.hasOwnProperty.call(searchParams, key) && searchParams[key] === undefined) {
                searchParams[key] = '';
            }
        }

        // TODO: remove it later
        if (searchParams.folder && !searchParams.status) {
            switch (searchParams.folder) {
                case null:
                case TicketFolder.notArchived as any:
                    searchParams.status = TicketStatus.completed;
                    break;

                case TicketFolder.closed:
                    searchParams.status = TicketStatus.notCompleted;
                    break;

                case TicketFolder.open:
                    searchParams.status = TicketStatus.open;
                    break;

                case TicketFolder.pending:
                    searchParams.status = TicketStatus.pending;
                    break;

                case TicketFolder.allTickets:
                    searchParams.status = null;
                    break;
            }
        }

        return searchParams;
    }

    private isSearchChanged(params: Params): boolean {
        const isSearchChanged =
            this.isFirstLoad ||
            this._queryParams['filterId'] !== params['filterId'] ||
            this._queryParams['usersQuery'] !== params['usersQuery'] ||
            this._queryParams['threadQuery'] !== params['threadQuery'] ||
            this._queryParams['fieldsQuery'] !== params['fieldsQuery'] ||
            // count: this.count,
            // skip: this.tickets.length,
            this._queryParams['folder'] !== params['folder'] ||
            this._queryParams['sentiment'] !== params['sentiment'] ||
            this._queryParams['source'] !== params['source'] ||
            this._queryParams['tagIds'] !== params['tagIds'] ||
            this._queryParams['fields'] !== params['fields'] ||
            this._queryParams['categoryIds'] !== params['categoryIds'] ||
            this._queryParams['orderBy'] !== params['orderBy'] ||
            this._queryParams['onlyMy'] !== params['onlyMy'] ||
            this._queryParams['fromDate'] !== params['fromDate'] ||
            this._queryParams['toDate'] !== params['toDate'] ||
            this._queryParams['isOnlyHelperCategories'] !== params['isOnlyHelperCategories'] ||
            this._queryParams['sourceSubtype'] !== params['sourceSubtype'] ||
            this._queryParams['replyFromDate'] !== params['replyFromDate'] ||
            this._queryParams['replyToDate'] !== params['replyToDate'] ||
            this._queryParams['hasAttachments'] !== params['hasAttachments'] ||
            this._queryParams['hasNoReplyFromTeam'] !== params['hasNoReplyFromTeam'] ||
            this._queryParams['withoutCategory'] !== params['withoutCategory'] ||
            this._queryParams['repliedBy'] !== params['repliedBy'] ||
            this._queryParams['createdBy'] !== params['createdBy'] ||
            this._queryParams['isAssignedToBot'] !== params['isAssignedToBot'] ||
            this._queryParams['query'] !== params['query'] ||
            this._queryParams['status'] !== params['status'] ||
            this._queryParams['lastUpdateDaysDuration'] !== params['lastUpdateDaysDuration'] ||
            this._queryParams['closedByAnyAgentFromGroup'] !== params['closedByAnyAgentFromGroup'] ||
            this._queryParams['closedByAgent'] !== params['closedByAgent'] ||
            this._queryParams['assignees'] !== params['assignees'] ||
            this._queryParams['assigneeUserGroupIds'] !== params['assigneeUserGroupIds'] ||
            this._queryParams['isAssigned'] !== params['isAssigned'] ||
            this._queryParams['creationDateFilterType'] !== params['creationDateFilterType'] ||
            this._queryParams['creationDateFilterUnit'] !== params['creationDateFilterUnit'] ||
            this._queryParams['creationDateFilterValue'] !== params['creationDateFilterValue'] ||
            this._queryParams['linkedToTicket'] !== params['linkedToTicket'];

        return isSearchChanged;
    }

    private isCurrentSourceEmpty(): boolean {
        switch (this.queryParams.source) {
            case 'chat':
                return !this.commonDataService.socialMediaStatuses.chatTickets;
            case 'facebook':
                return !this.commonDataService.socialMediaStatuses.facebookTickets;
            case 'instagram':
                return !this.commonDataService.socialMediaStatuses.instagramTickets;
            default:
                return false;
        }
    }

    private setOrderBy(params: { [x: string]: any }): void {
        if (params['orderBy']) {
            this.orderBy = Number(params['orderBy']);
        }

        // todo: refactor it
        if (!this.orderBy) {
            let ticketListSortingSettings = JSON.parse(
                this.windowRef.nativeWindow.localStorage.getItem('ticketListSortingSettings'),
            );

            if (!ticketListSortingSettings) {
                ticketListSortingSettings = {
                    defaultCommunityTicketListSorting: this.commonDataService.customerSettings.defaultTicketListSorting,
                    defaultCommunityTicketListSortingLastUpdatedTime:
                        this.commonDataService.customerSettings.defaultTicketListSortingLastUpdatedTime,
                    ticketListSorting:
                        this.commonDataService.customerSettings.defaultTicketListSorting ||
                        Number(this.windowRef.nativeWindow.localStorage.getItem('orderBy')) ||
                        OrderBy.lastThreadActivityDesc,
                };
            } else {
                if (
                    (ticketListSortingSettings.defaultCommunityTicketListSorting !==
                        this.commonDataService.customerSettings.defaultTicketListSorting &&
                        this.commonDataService.customerSettings.defaultTicketListSorting !== null) ||
                    (ticketListSortingSettings.defaultCommunityTicketListSortingLastUpdatedTime !==
                        this.commonDataService.customerSettings.defaultTicketListSortingLastUpdatedTime &&
                        this.commonDataService.customerSettings.defaultTicketListSortingLastUpdatedTime !== null)
                ) {
                    ticketListSortingSettings = {
                        defaultTicketListSorting: this.commonDataService.customerSettings.defaultTicketListSorting,
                        defaultCommunityTicketListSortingLastUpdatedTime:
                            this.commonDataService.customerSettings.defaultTicketListSortingLastUpdatedTime,
                        ticketListSorting: this.commonDataService.customerSettings.defaultTicketListSorting,
                    };
                }
            }

            this.windowRef.nativeWindow.localStorage.setItem(
                'ticketListSortingSettings',
                JSON.stringify(ticketListSortingSettings),
            );

            this.orderBy = Number(ticketListSortingSettings.ticketListSorting);
        } else if (
            !this.commonDataService.customerSettings.isSlaEnabled &&
            this.orderBy === this.orderByEnum.expirationTimeAsc
        ) {
            this.orderBy = OrderBy.lastThreadActivityDesc;
        }
    }

    private getTotalResultCount() {
        if (this.totalResultsCount === null) {
            if (this.tickets.length % this.count === 0) {
                return 'many';
            } else {
                return this.tickets.length;
            }
        } else {
            return this.totalResultsCount;
        }
    }

    private selectFirstTicketInList(): void {
        if (this.tickets.length) {
            this.selectedTicketItemId = this.tickets[0].id;
            this.finishSearchContextTransition();
            this.ticketDetailsPanelService.open(this.tickets[0].id, true, true);
        } else {
            this.selectedTicketItemId = null;
            this.finishSearchContextTransition();
            this.ticketDetailsPanelService.close();
        }
    }

    private updateEmptyStates(): void {
        this.emptyTicketsTitle = this.getEmptyTicketsTitle();
        this.showEmptyTicketsState =
            !this.isLoadingTickets &&
            !this.isNoTicketsMatchThisCriteria &&
            !this.tickets.length &&
            !(this.commonDataService.socialMediaStatusesLoaded && this.isCurrentSourceEmpty());
        this.showTicketDetailsEmptyState =
            this.hasExplicitEmptySelection() &&
            !this.selectedTicketItemId &&
            !this.ticketDetailsPanelService.isTicketDetailsOpened &&
            !this.isSearchContextTransitioning &&
            !this.selectedTickets.length;
    }

    private getEmptyTicketsTitle(): string {
        switch (this.activeStatus) {
            case TicketStatus.open:
                return 'No open tickets';
            case TicketStatus.pending:
                return 'No pending tickets';
            case TicketStatus.completed:
                return 'No closed tickets';
            default:
                return 'No tickets';
        }
    }

    private shouldAutoSelectFirstTicket(): boolean {
        return !this.selectedTickets.length && !this.hasExplicitEmptySelection();
    }

    private hasExplicitEmptySelection(): boolean {
        return this.activatedRoute.snapshot.queryParams.emptySelection === '1';
    }

    private finishSearchContextTransition(): void {
        this.isSearchContextTransitioning = false;
        this.updateEmptyStates();
    }

    private updateTicketListItem(ticketId: number, ticket: Partial<TicketSignalRDTO>): void {
        const listItem = this.tickets.find((item) => item.id === ticketId);

        if (!listItem) {
            return;
        }

        // SignalR partial updates can send null for unchanged nullable fields; keep the current auth state.
        const ticketUpdate =
            ticket.sessionAuthentication === null && listItem.sessionAuthentication
                ? { ...ticket, sessionAuthentication: listItem.sessionAuthentication }
                : ticket;

        Object.assign(listItem, ticketUpdate);
        listItem.changeDetectionMarker = new Date().getTime();
    }

    private scrollToView(element, parent): boolean {
        element = $(element);
        parent = $(parent);

        const offset = element.offset().top + parent.scrollTop();

        const height = element.innerHeight();
        const offsetEnd = offset + height;
        if (!element.is(':visible')) {
            element.css({ visibility: 'hidden' }).show();
            // const offset = element.offset().top;
            element.css({ visibility: '', display: '' });
        }

        const visibleAreaStart = parent.scrollTop();
        const visibleAreaEnd = visibleAreaStart + parent.innerHeight();

        if (offset - height < visibleAreaStart - 10) {
            parent.animate({ scrollTop: offset - height - 50 }, 100);
            return false;
        } else if (offsetEnd > visibleAreaEnd) {
            parent.animate({ scrollTop: parent.scrollTop() + offsetEnd - visibleAreaEnd }, 100);
            return false;
        }
        return true;
    }

    private selectTicket(ticket): void {
        if (ticket) {
            if (
                !this.selectedTickets.find((selectedTicket) => {
                    return selectedTicket.id === ticket.id;
                })
            ) {
                this.selectedTickets.push(ticket);
                ticket.isSelected = true;
            }
        }
    }

    ngOnDestroy(): void {
        this.unsubscriber.next();
        this.unsubscriber.complete();
    }
}
